import { ProductCategories } from '@domains/product';

export const getFirstCategorySlug = (categories: ProductCategories) =>
    categories?.length > 0 ? categories[0].slug : undefined;
